














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Tooltip extends Vue {
  @Prop({ required: true }) text: string;

  $refs: {
    widget: HTMLElement
  };

  mounted () {
    ($(this.$refs.widget) as any).protipSet();
  }
}
